import React, { createContext, ReactNode, useContext } from 'react';
import { notification, NotificationArgsProps } from 'antd';

interface NotificationContextValue {
  showNotification: (notification: NotificationArgsProps & { skip?: boolean }) => void;
}

const NotificationContext = createContext<NotificationContextValue | undefined>(undefined);

interface NotificationProviderProps {
  children: ReactNode;
}

export const NotificationProvider: React.FC<NotificationProviderProps> = ({ children }) => {
  const [api, contextHolder] = notification.useNotification({
    pauseOnHover: true,
  });

  const showNotification = ({
    type = 'info',
    message,
    description,
    duration = 3,
    skip,
  }: NotificationArgsProps & { skip?: boolean }) => {
    if (skip) {
      return;
    }
    api[type]({
      message,
      description,
      duration,
    });
  };

  return (
    <NotificationContext.Provider value={{ showNotification }}>
      {contextHolder}
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotification must be used within a NotificationProvider');
  }
  return context;
};
